import 'regenerator-runtime'
import Vue from 'vue'
import store from './store'
import WorkApp from './WorkApp.vue'

import router from './router'
import vuetify from './plugins/vuetify';
import uncaughtErrorHandler from './plugins/uncaught-error-handler';
import cookies from 'vue-cookies'
import axios from 'axios';
import i18n from './language/i18n';
import FlagIcon from 'vue-flag-icon';

import interceptor from './middlewares/axios/axios-custom-interceptor'
import webSocketService from './services/web-socket-service.js'

import '@/utils/global-components';
import '@/utils/validation';

import breakpoint from './mixins/breakpoints-mixin.js';

import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import MobileDetection from "@/plugins/MobileDetection";
import NavigationPlugin from "@/plugins/NavigationPlugin";
import VueHtml2Canvas from 'vue-html2canvas';
import MobileDeviceBridge from "@/mobile-device-bridge/MobileDeviceBridge";
import WorkCookies from "@/services/cookie_services/WorkCookies";

Vue.config.productionTip = false

Vue.use(cookies)
Vue.use(FlagIcon)
Vue.use(uncaughtErrorHandler);
Vue.use(MobileDetection);
Vue.use(NavigationPlugin);
Vue.mixin(breakpoint);
Vue.use(VueHtml2Canvas);
Vue.use(MobileDeviceBridge);

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'md'
})

Vue.filter('emptyValueAsHyphen', function (value) {
  if (value != undefined && value != "") { return value }
  return '-';
});

const token = cookies.get('token')
if (token) {
  axios.defaults.headers.common['X-AUTH-TOKEN'] = token;
  if(!token.startsWith('-extern-'))
    webSocketService.createConnectionToBackend(token);
}

const actingUser = store.state.actingUser.userToActFor
if (actingUser !== null) {
  axios.defaults.headers.common['ACTING-USER'] = actingUser
}

const deputyTypeId = store.state.actingUser.deputyTypeId
if (deputyTypeId !== null) {
  axios.defaults.headers.common['DEPUTY-TYPE'] = deputyTypeId
}

const activeLanguage = cookies.get('active-language')
if (activeLanguage) {
  i18n.locale = WorkCookies.getLangugage();
}

interceptor();

new Vue({
  render: h => h(WorkApp),
  vuetify,
  store,
  router,
  cookies,
  i18n,
}).$mount('#app')
